// extracted by mini-css-extract-plugin
export var option = "_2x-0";
export var optionSelected = "_2x-1 _2x-0";
export var optionUnselected = "_2x-2 _2x-0";
export var radioInner = "_2x-5";
export var radioOuter = "_2x-3";
export var radioOuterSelected = "_2x-4 _2x-3";